import { useQuery } from '@tanstack/react-query';
import { authenticatedFetch } from '../lib/api';

export type PipelineKind = 'sales' | 'purchases';

export type PipelineOverviewCounts = {
  rfqs: number;
  offers: number;
  purchaseOrders: number;
  inProgress: number;
  ordersDelivered: number;
  claims: number;
  completedOrders: number;
};

const EMPTY_COUNTS: PipelineOverviewCounts = {
  rfqs: 0,
  offers: 0,
  purchaseOrders: 0,
  inProgress: 0,
  ordersDelivered: 0,
  claims: 0,
  completedOrders: 0,
};

/**
 * Live totals for Sales / Purchases overview tiles.
 * Uses a dedicated counts endpoint so overview does not download list payloads.
 */
export function usePipelineOverviewCounts(
  pipeline: PipelineKind,
  enabled = true
) {
  const query = useQuery({
    queryKey: ['admin-pipeline-overview', pipeline],
    enabled,
    queryFn: async () => {
      const response = await authenticatedFetch(
        `/api/v1/admin/pipeline-overview?pipeline=${pipeline}`
      );
      if (!response.ok) throw new Error('Failed to fetch pipeline overview');
      const json = await response.json();
      return (json.data || EMPTY_COUNTS) as PipelineOverviewCounts;
    },
  });

  return {
    counts: query.data ?? EMPTY_COUNTS,
    isLoading: enabled && query.isLoading,
  };
}
